import { render, staticRenderFns } from "./SendOtpActivation.vue?vue&type=template&id=d0bd76de"
import script from "./SendOtpActivation.vue?vue&type=script&lang=js"
export * from "./SendOtpActivation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports